import { ManagedClassroomOrderByQuery } from "generated/CoreApi_v1";
import React, { PropsWithChildren } from "react";
import { Outlet } from "react-router";
import { IAdvFilterParams } from "views/general/AdvancedFilter";

////////////////////////////////////////////////////////////////////////////////

export interface ClassroomListFilter extends IAdvFilterParams<ManagedClassroomOrderByQuery> {
    onlyActive: boolean;
}

type ClassroomListPagination = {
    page: number;
};

type ClassroomContextType = {
    filter: ClassroomListFilter;
    setFilter: (data: Partial<ClassroomListFilter>) => void;
    resetFilter: () => void;

    pagination: ClassroomListPagination;
    setPagination: (data: ClassroomListPagination) => void;

};

const ClassroomContext = React.createContext<ClassroomContextType>(undefined!);

////////////////////////////////////////////////////////////////////////////////

export const useClassroomManagementContext = () => React.useContext(ClassroomContext);

////////////////////////////////////////////////////////////////////////////////

const ClassroomManagementWrapper: React.FC<PropsWithChildren> = () => {
    const [filter, setFilter] = React.useState<ClassroomListFilter>({ searchText: "", onlyActive: true, order: ManagedClassroomOrderByQuery.Name, advFilters: [] });
    const [pagination, setPagination] = React.useState<ClassroomListPagination>({ page: 1 });

    const resetFilter = () => {
        setFilter(state => ({ ...state, searchText: "" }));
        setPagination({ page: 1 });
    };

    return (
        <ClassroomContext.Provider
            value={
                {
                    filter,
                    setFilter: (data: Partial<ClassroomListFilter>) => setFilter(state => ({ ...state, ...data })),
                    resetFilter,

                    pagination,
                    setPagination: (data: ClassroomListPagination) => setPagination(data)
                }
            }
        >
            <Outlet />
        </ClassroomContext.Provider>
    );
};

export default ClassroomManagementWrapper;